import React from "react";
import ReactDOM from "react-dom/client";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./components/login";
import Dashboard from "./components/dashboard";
import Worksheets from "./components/worksheets";
import Fitters from "./components/fitters";
import Users from "./components/users";
import UnsubmittedWorksheetsReport from "./components/unsubmittedWorksheetsReport";
import MeasureRevisits from "./components/measureRevisits";
import QueryInstalls from "./components/queryInstalls";
import EcoJobs from "./components/ecoJobs";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={"/"}>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="" element={<Login />} />
        </Route>

        <Route path="/login" element={<Login />}></Route>
        <Route path="/dashboard" element={<Dashboard />}></Route>
        <Route path="/worksheets" element={<Worksheets />}></Route>
        <Route path="/fitters" element={<Fitters />}></Route>
        <Route path="/measureRevisits" element={<MeasureRevisits />}></Route>
        <Route path="/queryInstalls" element={<QueryInstalls />}></Route>
        <Route path="/users" element={<Users />}></Route>
        <Route path="/reports/unsubmittedWorksheetsReport" element={<UnsubmittedWorksheetsReport />}></Route>
        <Route path="/ecoJobs" element={<EcoJobs />}></Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
